import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.BannerB');
    const { locale = 'us' } = getLocal();
    const { asPath } = useRouter();

    const IS_JP_SITE = ['jp'].includes(locale);

    const btnLink = useMemo(() => {
        const query = String(asPath.split('?')[1])?.split('#')[0];
        switch (locale) {
            case 'us':
                return 'https://us.ecoflow.com/products/ecoflow-glacier-classic-portable-fridge-freezer';
            case 'ca':
                return 'https://ca.ecoflow.com/products/ecoflow-glacier-classic-portable-fridge-freezer';
            case 'jp':
                return `glacier-classic-portable-refrigerator/bundles${query !== 'undefined' ? `?${query}` : ''}`;
            case 'au':
                return 'https://au.ecoflow.com/products/ecoflow-glacier-classic-portable-fridge-freezer';
            default:
                return `https://${locale}.ecoflow.com/products/glacier-classic-portable-fridge-freezer`;
        }
    }, [asPath, locale]);

    const dataA: EcoBannerProps = {
        layout: 'top-center',

        pc: IS_JP_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1745379118141/KV.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1744890816767/kv.jpg',
        h5: IS_JP_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1745379117928/kv-h5.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1744890824909/kv_M.jpg',
        // label: t('label'),
        title: t('title'),
        subTitle: t('subTitle'),
        desc: t('desc'),

        theme: 'white',
        lChildren: t('buynow'),
        lHref: btnLink,
        lType: 'filled',
        lDataLayer:
            locale === 'jp'
                ? {
                      event: 'uaEvent',
                      event_name: 'checkout',
                      button_name: `${t('buynow')}_${t('title')}`,
                  }
                : {
                      event: 'uaEvent',
                      event_name: 'buy',
                      product_name: t('title'),
                      position: `Product Detail_${t('title')}`,
                  },

        rChildren: t('video'),
        rHref: locale === 'jp' ? 'https://www.youtube.com/embed/YabkLQsQu5Q' : 'https://www.youtube.com/embed/SYjOmBQ9PCQ',
        rType: 'outlined',
        rBtnIsYouToBe: true,
    };

    const [bannerHeight, setBannerHeight] = useState(800);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const callback = () => {
                const { height = 0 } = document.querySelector('.ecoflow-frame-header')?.getBoundingClientRect() ?? {};
                const { height: navHeight = 0 } = document.querySelector('.eco-nav-product')?.getBoundingClientRect() ?? {};
                // @ts-ignore
                setBannerHeight(window.innerHeight - height - navHeight);
            };
            if (window.innerWidth < 1024) {
                setTimeout(() => {
                    callback();
                }, 0);
            } else {
                callback();
                window.addEventListener('resize', callback);
                return () => window.removeEventListener('resize', callback);
            }
        }
    }, []);
    return (
        <div className={styles.comp} style={{ '--banner-height': `${bannerHeight}px` }}>
            <EcoBanner {...dataA} />
        </div>
    );
}
